import { Link, useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";

export const AccountMenu = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  if (!user) return <Link to="/account" aria-label="Log in or create an account" title="Log in" className="relative p-2 transition-opacity hover:opacity-60" data-testid="header-account-button"><User size={20} strokeWidth={1.5} /></Link>;
  const go = (tab) => navigate(`/account?tab=${tab}`);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="relative flex items-center gap-1.5 rounded-full p-2 transition-opacity hover:opacity-60" aria-label="Account menu" data-testid="header-account-button">
        <User size={20} strokeWidth={1.5} /><span className="label hidden rounded-full bg-lime px-2 py-0.5 !text-[10px] font-bold sm:inline" data-testid="header-points">{user.points} pts</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-[16px] border-[1.5px] border-ink bg-cloud p-2" data-testid="header-account-menu">
        <DropdownMenuLabel className="font-a">{user.name || user.email}<span className="label mt-1 block text-ink/60" data-testid="header-menu-points">{user.points} Crew Points</span></DropdownMenuLabel>
        <DropdownMenuSeparator />
        {[["profile", "My account"], ["orders", "Orders"], ["points", "Points history"], ["rewards", "Rewards"]].map(([t, l]) => <DropdownMenuItem key={t} onSelect={() => go(t)} className="rounded-[10px]" data-testid={`header-menu-${t}`}>{l}</DropdownMenuItem>)}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={signOut} className="rounded-[10px]" data-testid="header-menu-logout">Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
